import { type ElementType, useRef } from "react";
import { type AriaButtonOptions, useButton } from "react-aria";
import { type Color, parseColor } from "react-stately";

export interface ColorSelectProps<E extends ElementType> extends AriaButtonOptions<E> {
  color: string;
  onPressSetColor?: (color: Color) => void;
}

export const ColorSelect = <E extends ElementType>(props: ColorSelectProps<E>) => {
  const ref = useRef<HTMLDivElement>(null);
  const color = parseColor(props.color);
  const onPress = props.onPress ?? (() => props.onPressSetColor?.(color));
  const { buttonProps } = useButton({ ...props, onPress, elementType: "div" }, ref);

  return (
    <div
      data-testid="color-select"
      ref={ref}
      {...buttonProps}
      style={{ width: 18, flex: 1, backgroundColor: color.toFormat("rgb").toString("css"), outline: 0 }}
    />
  );
};
